import { Typography } from '@mui/material';
import { header } from '~/layouts/AdminHeader/AdminHeader.style';
import { AdminHeaderProfile } from '~/layouts/AdminHeader/AdminHeaderProfile';

export const LatestNewsHeader = () => {
  return (
    <header.Container>
      <header.LeftCluster>
        <Typography
          component="h1"
          sx={{ fontWeight: 700, fontSize: '1.1rem', color: 'grey.900' }}
        >
          最新消息
        </Typography>
      </header.LeftCluster>
      <AdminHeaderProfile />
    </header.Container>
  );
};
